//src/XIcon.tsx hardened/refactored v1

//X social media icon for footer

const XIcon = ({ size = 28, className = '' }) => {
  // For a line at 45° (from (4,4) to (20,20)), the perpendicular unit vector is (1/√2, -1/√2).
  // We want an outer offset of 2 (along the perpendicular) and an inner offset of 1.
  // Thus, the computed offsets are:
  const outerOffset = 2 / Math.SQRT2; // ≈ 1.414
  const innerOffset = 1 / Math.SQRT2; // ≈ 0.707

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
    >
      {/*
        Parallelogram for the (4,4)-(20,20) diagonal:
        We create a polygon that runs along the diagonal line but
        is offset perpendicularly by outerOffset. Then we subtract (cut out)
        an inner polygon defined by innerOffset.
      */}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d={`
          M ${4 + outerOffset} ${4 - outerOffset}
          L ${20 + outerOffset} ${20 - outerOffset}
          L ${20 - outerOffset} ${20 + outerOffset}
          L ${4 - outerOffset} ${4 + outerOffset}
          Z
          M ${4 + innerOffset} ${4 - innerOffset}
          L ${20 + innerOffset} ${20 - innerOffset}
          L ${20 - innerOffset} ${20 + innerOffset}
          L ${4 - innerOffset} ${4 + innerOffset}
          Z
        `}
      />
      
      {/*
        Simple diagonal line for the (20,4)-(4,20) diagonal.
      */}
      <line
        x1="20"
        y1="4"
        x2="4"
        y2="20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default XIcon;
